import { Component, inject, input } from '@angular/core';
import { OverlayRef } from 'app/shared/ui/overlays';


@Component({
    selector: 'modal-header',
    styles: [
        `
        :host {
            flex: 1 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 1rem;
            border-top-left-radius: 0.3rem;
            border-top-right-radius: 0.3rem;
        }
        .modal-title {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex: 1 1 auto;
            font-size: 1rem;
            font-weight: bold;
        }
        .close {
            line-height: 1;
            opacity: .5;
        }
        .close:hover {
            opacity: 1;
        }
        .close img {
            filter: invert(100%);
        }
        `,
    ],
    host: {
        '[class]': '"bg-" + type() + " modal-header text-white"',
    },
    template: `
        <div class="modal-title">
            <ng-content></ng-content>
        </div>
        @if (closeable()) {
            <button type="button" class="close" title="Close" (click)="close()">
                <img src="/assets/images/ui/close.svg" alt="X">
            </button>
        }
    `,
})
export class ModalHeaderComponent {

    type = input('brand');

    closeable = input(true);

    private overlayRef = inject(OverlayRef);

    close() {
        this.overlayRef.dismiss('close');
    }
}
